import type { LegalPageContent } from '@/types/pageContent';

export const DEFAULT_TERMS: LegalPageContent = {
    lastUpdated: '2025-12-01',
    sections: [
        {
            heading: 'Introduction',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'Welcome to Stork Rentals. These Terms & Conditions govern your use of our baby equipment rental service. By placing an order, you agree to be bound by these terms.',
                },
                {
                    title: '',
                    body: 'Stork Rentals provides premium baby equipment for short-term and long-term rentals to traveling families and local residents. We are committed to providing clean, safe, and high-quality equipment for your little ones.',
                },
            ],
        },
        {
            heading: 'Rental Agreement',
            style: 'default',
            items: [
                {
                    title: 'Rental Period',
                    body: 'The rental period begins at the designated pickup time on your start date and ends at the designated return time on your end date.',
                },
                {
                    title: 'Equipment Condition',
                    body: 'All equipment is thoroughly cleaned and sanitized between rentals. You will receive equipment in excellent working condition.',
                },
                {
                    title: 'Intended Use',
                    body: 'Equipment must be used only for its intended purpose and in accordance with manufacturer guidelines. Equipment must not be modified, disassembled, or used in an unsafe manner.',
                },
                {
                    title: 'Age/Weight Limits',
                    body: 'You are responsible for ensuring the equipment is appropriate for your child\'s age, weight, and height. Please review product specifications carefully.',
                },
            ],
        },
        {
            heading: 'Payments & Deposits',
            style: 'default',
            items: [
                {
                    title: 'Rental Fees',
                    body: 'Rental fees are calculated based on the rental duration and displayed at checkout. Prices include applicable taxes.',
                },
                {
                    title: 'Security Deposit',
                    body: 'A refundable security deposit is required for all rentals. This deposit is held as a pre-authorization on your card and will be released within 5-10 business days after the equipment is returned in good condition.',
                },
                {
                    title: 'Damage Charges',
                    body: 'If equipment is returned damaged beyond normal wear and tear, repair or replacement costs may be deducted from your security deposit. You will be notified of any charges.',
                },
                {
                    title: 'Payment Methods',
                    body: 'We accept major credit and debit cards through our secure payment processor (Stripe). All transactions are encrypted and secure.',
                },
            ],
        },
        {
            heading: 'Cancellation & Refunds',
            style: 'default',
            items: [
                {
                    title: 'Free Cancellation',
                    body: 'Cancel more than 24 hours before your rental start date for a full refund of rental fees. Security deposit authorizations are released immediately.',
                },
                {
                    title: 'Late Cancellation',
                    body: 'Cancellations within 24 hours of the rental start date may be subject to a cancellation fee of up to 50% of the rental total.',
                },
                {
                    title: 'No-Show',
                    body: 'If you do not pick up your equipment and do not contact us, the full rental fee is non-refundable.',
                },
                {
                    title: 'Refund Processing',
                    body: 'Approved refunds are processed within 5-10 business days. The time for funds to appear in your account depends on your bank.',
                },
            ],
        },
        {
            heading: 'Pickup & Return',
            style: 'default',
            items: [
                {
                    title: 'Pickup',
                    body: 'Equipment must be collected from our designated pickup location during operating hours. Please bring your order confirmation and a valid ID.',
                },
                {
                    title: 'Return',
                    body: 'Equipment must be returned to the same location by the end of your rental period. Please return items in the condition received, with all accessories and parts.',
                },
                {
                    title: 'Late Returns',
                    body: 'Returns after the designated time may incur additional daily charges. Please contact us if you need to extend your rental.',
                },
                {
                    title: 'Extensions',
                    body: 'Rental extensions are subject to availability and must be requested at least 24 hours before your return date.',
                },
            ],
        },
        {
            heading: 'Liability & Safety',
            style: 'default',
            items: [
                {
                    title: 'Your Responsibility',
                    body: 'You are responsible for the proper use and care of rented equipment during the rental period. This includes supervision of children using the equipment.',
                },
                {
                    title: 'Safety Compliance',
                    body: 'All our equipment meets relevant safety standards (EU regulations). However, you must follow all safety instructions and manufacturer guidelines.',
                },
                {
                    title: 'Limitation of Liability',
                    body: 'Stork Rentals is not liable for any injury, damage, or loss arising from improper use of equipment or failure to follow safety guidelines.',
                },
                {
                    title: 'Insurance',
                    body: 'We recommend you have adequate travel or home insurance that covers rental equipment. We are not responsible for loss or theft.',
                },
            ],
        },
        {
            heading: 'Contact Us',
            style: 'list',
            items: [
                {
                    title: '',
                    body: 'If you have any questions about these Terms & Conditions, please contact us:',
                },
                {
                    title: 'Email',
                    body: 'info@thestorkexchange.ie',
                },
                {
                    title: 'Phone',
                    body: '+34 900 000 000',
                },
                {
                    title: 'Contact Form',
                    body: '/contact',
                },
            ],
        },
        {
            heading: 'Governing Law',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'These Terms & Conditions are governed by and construed in accordance with the laws of Spain. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Barcelona, Spain.',
                },
            ],
        },
    ],
};
